import * as React from 'react';
import { useCallback, useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import { ChipStatus, DialogForm, IChipsSettingProps, IDialogActions, ISnackbarAlert, SnackbarAlert } from '../../../shared/components';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import Timeline from '@mui/lab/Timeline';
import { GenericService } from '../../../shared/services';
import { formatDateTime, getAttribute, getLabel } from '../../../shared/utils';
import { AccessRoleDTO, AccessRoleFilterDTO, HistoricalStatusFilterDTO } from '../../../shared/interfaces';
import { ListId, LocalStorange } from '../../../shared/environment';
import { useTranslation } from 'react-i18next';

interface IHistoricalStatusTimeLineProps {
    title: string;
    ownerId: string;
    setIsOpenMaintenance: (value: boolean) => void;
    isOpenMaintenance: boolean;
    setActionExecuted: (value: boolean) => void;
    chipSettings?: IChipsSettingProps[];
}

export const HistoricalStatusTimeLine: React.FC<IHistoricalStatusTimeLineProps> = ({ title, ownerId, setIsOpenMaintenance, isOpenMaintenance, setActionExecuted, chipSettings }) => {
    const [historicalStatusList, setHistoricalStatusList] = useState<any>([]);
    const [historicalStatusFilterDTO, setHistoricalStatusFilterDTO] = useState<HistoricalStatusFilterDTO>();

    const [loading, setLoading] = useState(false);
    const [snackBarAlert, setSnackBarAlert] = useState<ISnackbarAlert>();
    const [isOpenMessage, setIsOpenMessage] = useState(false);

    const [accessRolePermissionDTO, setAccessRolePermissionDTO] = useState<AccessRoleDTO>();
    const userInfo = JSON.parse(localStorage.getItem(LocalStorange.USERINFO) || '');
    const { t } = useTranslation();

    useEffect(() => {
        setHistoricalStatusFilterDTO({
            ...historicalStatusFilterDTO,
            id: '',
            statusId: '',
            ownerId: ownerId
        } as HistoricalStatusFilterDTO);


    }, [ownerId]);

    useEffect(() => {
        handleHistoricalStatusGetAllView(ownerId);
    }, [ownerId, isOpenMaintenance]);

    const handleHistoricalStatusGetAllView = useCallback(async (ownerId: string) => {
        const filter = {
            ownerId: ownerId
        };

        GenericService.GetAllViewAsync1('historicalsphere.historicalStatus', filter, setActionExecuted, setLoading, setHistoricalStatusList, showMessage, true);
    }, [ownerId]);

    const actions: IDialogActions[] = [
        { id: 'close', text: t('historicalSphere.historicalStatusTimeLine.dialogActions.close'), icon: 'close_outlined', iconColor: 'primary', setAction: () => void undefined },
    ];

    function showMessage(message: string, type: 'error' | 'info' | 'success' | 'warning') {
        const msg: ISnackbarAlert = {
            id: 'message',
            message: message,
            type: type,
        };
        setSnackBarAlert(msg);
        setIsOpenMessage(true);
    }

    return (
        <React.Fragment>
            <SnackbarAlert
                snackBarAlert={snackBarAlert}
                setIsOpen={setIsOpenMessage}
                isOpen={isOpenMessage}
            />
            <DialogForm
                title={title}
                icon='dynamic_feed_outlined'
                setIsOpen={setIsOpenMaintenance}
                isOpen={isOpenMaintenance}
                fullWidth={true}
                maxWidth={'sm'}
                actions={actions}
                loading={loading}
            >
                <Timeline position="alternate" sx={{ gap: 1 }}>
                    <TimelineItem>
                        <TimelineSeparator>
                            <TimelineDot variant="outlined" color='error' />
                            <TimelineConnector />
                        </TimelineSeparator>
                        <TimelineContent>{t('vacancy.historyTimeline.end')}</TimelineContent>
                    </TimelineItem>
                    {historicalStatusList
                        .sort((a: { propertyToSortBy: number; }, b: { propertyToSortBy: number; }) => (a.propertyToSortBy < b.propertyToSortBy ? 1 : -1))
                        .map((row: any, index: number) => (
                            <Row
                                key={index}
                                row={row}
                                chipSettings={chipSettings}
                            />
                        ))}
                    <TimelineItem>
                        <TimelineSeparator>
                            <TimelineDot variant="outlined" color='success' />
                        </TimelineSeparator>
                        <TimelineContent>{t('vacancy.historyTimeline.start')}</TimelineContent>
                    </TimelineItem>
                </Timeline>
            </DialogForm>
        </React.Fragment >
    );
};

function Row(props: {
    row: any;
    chipSettings?: IChipsSettingProps[];
}) {
    const { row } = props;
    return (
        <React.Fragment>
            < TimelineItem >
                <TimelineSeparator sx={{ gap: 1 }}>
                    <ChipStatus
                        label={getAttribute(row, 'Status', 'label')}
                        value={getAttribute(row, 'Status', 'value')}
                        chipSettings={props.chipSettings}
                    />
                    <TimelineConnector />
                </TimelineSeparator>
                <TimelineContent>
                    <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                        {formatDateTime(getAttribute(row, 'creationDateTime', 'value'))}
                    </Typography>
                </TimelineContent>
            </TimelineItem>
        </React.Fragment >
    );
}
